<template>
    <div>
        <Head title="AffiliateInfo" />
        <h1 class="mb-8 text-3xl font-bold">Affiliate Info</h1>
        <div class="flex items-center justify-between mb-6">
            <Link class="btn-indigo" href="/affiliates/create">
                <span>Create</span>
                <span class="hidden md:inline">&nbsp;Affiliate</span>
            </Link>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                    <th class="pb-4 pt-6 px-6">ID</th>
                    <th class="pb-4 pt-6 px-6">Name</th>
                    <th class="pb-4 pt-6 px-6">Affiliate id</th>
                    <th class="pb-4 pt-6 px-6">CreatedAt</th>
                </tr>
                <tr v-for="affiliate in AffiliateInfo" :key="affiliate.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/affiliates/${affiliate.id}/edit`">
                            {{ affiliate.id }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4" :href="`/affiliates/${affiliate.id}/edit`" tabindex="-1">
                            {{ affiliate.name }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4" :href="`/affiliates/${affiliate.id}/edit`" tabindex="-1">
                            {{ affiliate.affiliate_id }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4" :href="`/affiliates/${affiliate.id}/edit`" tabindex="-1">
                            {{ affiliate.created_at }}
                        </Link>
                    </td>
                </tr>
                <tr v-if="AffiliateInfo.length === 0">
                    <td class="px-6 py-4 border-t" colspan="4">No Affiliates found.</td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchInput from '@/Shared/SearchInput'

export default {
    components: {
        Head,
        Icon,
        Link,
        SearchInput,
    },
    layout: Layout,
    props: {
        filters: Object,
        AffiliateInfo: Array,
    },
    data() {
        return {
            form: {
                search: this.filters.search
            },
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get('/affiliates', pickBy(this.form), { preserveState: true })
            }, 150),
        },
    },
    methods: {
        reset() {
            this.form = mapValues(this.form, () => null)
        },
    },
}
</script>
